import React from "react";
import { Box, Grid, Typography, Switch } from "@mui/material";
import { alpha } from "@mui/system";
import { SsidChart, CheckCircle, Cancel } from "@mui/icons-material";

const MetricToggle = ({ label, metricKey, checked, onToggle, styles, locked }) => (
	<Box 
		sx={{ 
			...styles?.boxSwitch, 
			opacity: locked ? 0.6 : 1, 
			pointerEvents: locked ? "none" : "auto" 
		}} 
		onClick={() => !locked && onToggle(metricKey)}
	>
		<Typography variant="body2" sx={{ color: "text.secondary", fontWeight: 600 }}>
			{label}
		</Typography>
		<Switch
			checked={checked}
			onChange={() => !locked && onToggle(metricKey)}
			onClick={(e) => e.stopPropagation()}
			sx={styles?.switch}
			checkedIcon={<CheckCircle sx={styles?.iconSwitch} />}
			icon={<Cancel sx={styles?.iconSwitch} />}
			focusVisibleClassName=".Mui-focusVisible"
			disableRipple
			disabled={locked}
		/>
	</Box>
);

export default function MetricasSection({
	theme,
	styles,
	metrics,
	handleToggleMetric,
	showTarifacao,
	showDisponibilidade,
	rules = [],
}) {
	const isMetricLocked = (metricKey) => {
		return rules.some(r => r.metric === metricKey && r.operator && r.value !== "");
	};

	return (
		<Box
			sx={{
				p: 2,
				bgcolor: theme.palette.background.paper,
				borderRadius: "12px",
				width: "100%",
				mb: 1,
			}}
		>
			{/* Cabeçalho */}
			<Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
				<Box
					sx={{
						backgroundColor: alpha(theme.palette.primary.main, 0.2),
						borderRadius: "10px",
						width: "35px",
						height: "35px",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
					}}
				>
					<SsidChart
						fontSize="small"
						sx={{
							color:
								theme.palette.mode === "dark"
									? theme.palette.primary.light
									: theme.palette.primary.dark,
						}}
					/>
				</Box>
				<Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
					Métricas e Tarifação
				</Typography>
			</Box>

			<Grid container spacing={1} sx={{ mt: 1 }}>
				{showTarifacao && (
					<>
						<Grid item xs={12} sm={6}>
							<MetricToggle
								label="Tráfego"
								metricKey="trafego"
								checked={metrics.trafego}
								onToggle={handleToggleMetric}
								styles={styles}
							/>
						</Grid>
						<Grid item xs={12} sm={6}>
							<MetricToggle
								label="Tarifação 95th"
								metricKey="tarifacao"
								checked={metrics.tarifacao}
								onToggle={handleToggleMetric}
								styles={styles}
							/>
						</Grid>
					</>
				)}

				{showDisponibilidade && (
					<Grid item xs={12} sm={6}>
						<MetricToggle
							label="Disponibilidade"
							metricKey="disponibilidade"
							checked={metrics.disponibilidade}
							onToggle={handleToggleMetric}
							styles={styles}
							locked={isMetricLocked("disponibilidade")}
						/>
					</Grid>
				)}

				<Grid item xs={12} sm={6}>
					<MetricToggle
						label="Perda de Pacote"
						metricKey="perdaPacote"
						checked={metrics.perdaPacote}
						onToggle={handleToggleMetric}
						styles={styles}
						locked={isMetricLocked("packetLoss")}
					/>
				</Grid>

				<Grid item xs={12} sm={6}>
					<MetricToggle
						label="Latência"
						metricKey="latencia"
						checked={metrics.latencia}
						onToggle={handleToggleMetric}
						styles={styles}
						locked={isMetricLocked("latencia")}
					/>
				</Grid>
			</Grid>
		</Box>
	);
}
